import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Optional,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { APIService } from '../../../../services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
// import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormComponent } from '../form/form.component';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-visit-form',
  templateUrl: './visit-form.component.html',
  styleUrls: ['./visit-form.component.scss'],
  standalone: false,
})
export class VisitFormComponent {
  @Input() title: string = '';
  @Input() submitButtonLabel: string = 'Submit';
  @Input() isEducationLevelRequired: boolean = true;
  @Input() id;
  @Output() close = new EventEmitter<void>();
  isSameNo: boolean = false;
  // @Output() submitForm = new EventEmitter<any>();

  visitReasons: string[] = [
    'Discuss admission process',
    'Explore school infrastructure',
    'Meet with teachers or staff',
    'Understand academic programs',
    'Check extracurricular activities',
    'Learn about school policies',
    'Tour the campus',
    'Address specific concerns',
  ];

  formData = {
    name: '',
    note: '',
    mobile: null,
    emailId: '',
    reason: '',
    schoolId: 0,
    // date: null as Date | null,
    date: '',
    whatsAppNo: null,
  };

  constructor(
    // @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VisitFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: APIService,
    public deviceDetectorService: DeviceDetectorService,
    private _snackBar: MatSnackBar // @Optional() public dialogRef: MatDialogRef<FormComponent>
  ) {}

  ngOnInit(): void {
    if (this.data.id) {
      this.formData.schoolId = this.data.id;
    } else {
      this.formData.schoolId = 0;
    }
    // this.formData.date = this.getNextMonday();
  }

  resetForm() {
    this.formData = {
      name: '',
      note: '',
      mobile: null,
      emailId: '',
      reason: '',
      schoolId: this.data.id,
      // date: null as Date | null,
      date: '',
      whatsAppNo: null,
    };
  }
  isNumber(val) {
    if (val) return /^\d+$/.test(val + '');
    return false;
  }

  waNoSelected(event: MatCheckboxChange) {
    this.isSameNo = event.checked;
    this.formData.whatsAppNo = this.isSameNo ? this.formData.mobile : null;
  }

  submitForm(): void {
    // console.log('Form submitted:', typeof this.formData.date);
    if (this.formData.date) {
      this.formData.date = this.formatDate(new Date(this.formData.date));
    }
    this.dialogRef.close(this.formData);
    this.api.createVisitEnquiry(this.formData).subscribe(
      (res) => {
        this._snackBar.open('Your details are submitted!', '', {
          duration: 6000,
        });
        this.resetForm();
      },
      (err) => {
        console.error('API Error:', err);
        this._snackBar.open('Your details are not submitted!', 'Resend', {
          duration: 6000,
        });
        this.resetForm();
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Date(date).toLocaleDateString('en-US', options);
  }

  // getNextMonday(): Date {
  //   const today = new Date();
  //   const dayOfWeek = today.getDay();
  //   const daysUntilNextMonday = (8 - dayOfWeek) % 7 || 7;
  //   const nextMonday = new Date(today);
  //   nextMonday.setDate(today.getDate() + daysUntilNextMonday);
  //   return nextMonday;
  // }

  // formatDate(date: Date): string {
  //   const options: Intl.DateTimeFormatOptions = {
  //     year: 'numeric',
  //     month: 'long',
  //     day: 'numeric',
  //   };
  //   return date.toLocaleDateString('en-US', options);
  // }

  submitDetails() {
    if (!this.isNumber(this.formData.mobile)) {
      this._snackBar.open('Invalid mobile no!', 'OK', {
        duration: 6000,
      });
      return;
    }
    console.log(typeof this.formData.date, this.formData.date);
    // this.api.createVisitEnquiry(this.formData).subscribe(
    //   (res) => {
    //     this._snackBar.open('Your details are submitted!', '', {
    //       duration: 6000,
    //     });
    //     this.resetForm();
    //   },
    //   (err) => {
    //     this._snackBar.open('Your details are not submitted!', 'Resend', {
    //       duration: 6000,
    //     });
    //     this.resetForm();
    //   }
    // );
  }

  closeModal() {
    this.close.emit();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
